// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBEGcQ5Ukfpv0uPfcv4bGsCObOM76X1mhA",
    authDomain: "mapdec.firebaseapp.com",
    databaseURL: "https://mapdec.firebaseio.com",
    projectId: "mapdec",
    storageBucket: "mapdec.appspot.com",
    messagingSenderId: "112540364348",
    appId: "1:112540364348:web:c1f2af361fb93ff96ddd39",
    measurementId: "G-TL9WFS2VE9"
  },
  googleClientId: "845839389008-s0scp3mghdi67t5ga9t56j6265ibonp5.apps.googleusercontent.com"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
